import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './TextField.module.scss';

const TextField = ({ children, htmlFor, labelName, tag, variant }) => {
  const { isDarkMode } = useTheme();

  return (
    <label
      data-bem="TextField"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.component]: true,
        [CN[`${variant}Variant`]]: variant,
        [CN.dark]: isDarkMode,
      })}
      htmlFor={htmlFor}
    >
      <span className={CN.labelName}>{labelName}</span>
      {children}
    </label>
  );
};

export default TextField;
